import {
  AutocompleteInput,
  email,
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { GenderOptionsId, PersonIdTypes } from "utils/choices";
import { nameCyrillicRegexValidator } from "utils/validations";
import { administrationRequests } from "api/administrationApi";
import { BULGARIA_COUNTRY_ID } from "utils/constants";

const SpecialistPersonalInfo = ({ foundUserInfo }) => {
  const isPrefilled = key => {
    if (!foundUserInfo) return false;
    const v = foundUserInfo[key];
    return v !== undefined && v !== null && v !== "";
  };

  return (
    <>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ mt: 2 }}
        >
          Информация за потребител
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.firstName"
          label="Име"
          validate={[required(), nameCyrillicRegexValidator]}
          disabled={isPrefilled("firstName")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.secondName"
          label="Презиме"
          parse={v => v ?? ""}
          format={v => v ?? ""}
          defaultValue=""
          disabled={isPrefilled("secondName")}
          validate={nameCyrillicRegexValidator}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.lastName"
          label="Фамилия"
          validate={[required(), nameCyrillicRegexValidator]}
          disabled={isPrefilled("lastName")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.email"
          label="Имейл"
          validate={[required(), email()]}
          disabled={isPrefilled("email")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="userInfo.contactPhone"
          label="Телефон"
          disabled={isPrefilled("contactPhone")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <SelectInput
          source="userInfo.gender"
          label="Пол"
          choices={GenderOptionsId}
          validate={[required()]}
          disabled={isPrefilled("gender")}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <SelectInput
          source="userInfo.personIdType"
          label="Тип идентификатор"
          choices={PersonIdTypes}
          disabled={isPrefilled("personIdType")}
          fullWidth
        />
      </Grid>
      <FormDataConsumer>
        {({ formData }) => (
          <Grid
            item
            xs={12}
            md={3}
          >
            <TextInput
              source="userInfo.personId"
              label={PersonIdTypes.find(x => x.id === formData.userInfo?.personIdType)?.name || "ЕГН"}
              validate={[required()]}
              parse={v => v?.trim()}
              disabled={isPrefilled("personId")}
              fullWidth
            />
          </Grid>
        )}
      </FormDataConsumer>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          reference={administrationRequests.getCountriesSelect()}
          source="userInfo.primaryCitizenshipCountryId"
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            label="Гражданство"
            defaultValue={isPrefilled("primaryCitizenshipCountryId") ? undefined : BULGARIA_COUNTRY_ID}
            disabled={isPrefilled("primaryCitizenshipCountryId")}
            validate={required()}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          reference={administrationRequests.getCountriesSelect()}
          source="userInfo.secondaryCitizenshipCountryId"
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            label="Второ гражданство"
            disabled={isPrefilled("secondaryCitizenshipCountryId")}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          source="userInfo.birthDate"
          label="Дата на раждане"
          disabled={isPrefilled("birthDate")}
          validate={required()}
          fullWidth
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="userInfo.birthCountryId"
          reference={administrationRequests.getCountriesSelect()}
        >
          <AutocompleteInput
            label="Държава на раждане"
            optionText="nameBg"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            defaultValue={isPrefilled("birthCountryId") ? undefined : BULGARIA_COUNTRY_ID}
            disabled={isPrefilled("birthCountryId")}
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          reference={administrationRequests.getSettlementsSelect()}
          source="userInfo.birthSettlementId"
          filter={{ showDistrictAndMunicipality: true, showPostalCode: true }}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            label="Място на раждане"
            disabled={isPrefilled("birthSettlementId")}
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
    </>
  );
};

export default SpecialistPersonalInfo;
